import { addDays, format } from 'date-fns';

export const PAYMENT_TERMS_OPTIONS = [
  { value: 'due_on_receipt', label: 'Due on Receipt', days: 0 },
  { value: 'net_7', label: 'Net 7', days: 7 },
  { value: 'net_15', label: 'Net 15', days: 15 },
  { value: 'net_30', label: 'Net 30', days: 30 },
  { value: 'net_45', label: 'Net 45', days: 45 },
  { value: 'net_60', label: 'Net 60', days: 60 },
  { value: 'net_90', label: 'Net 90', days: 90 },
  { value: 'custom', label: 'Custom', days: null },
] as const;

/**
 * Derive a due date (yyyy-MM-dd) from a base date and a payment-terms value.
 * Returns null for terms with no fixed day count (e.g. 'custom') so callers
 * leave the due date untouched.
 */
export function calculateDueDate(baseDate: Date, termsValue: string | undefined): string | null {
  const term = PAYMENT_TERMS_OPTIONS.find(t => t.value === termsValue);
  if (!term || term.days === null) return null;
  return format(addDays(baseDate, term.days), 'yyyy-MM-dd');
}
